import { lazy } from "react";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
} from "react-router-dom";
import LayoutHeader from "./components/LayoutHead";
import LayoutHeaderUser from "./components/LayoutHeadUser";

const Dashboard = lazy(() => import("./pages/Dashboard"));
const Drivers = lazy(() => import("./pages/Drivers"));
const DriversMapView = lazy(() => import("./pages/DriversMapView"));
const Login = lazy(() => import("./pages/Login"));
const NotFoundPage = lazy(() => import("./pages/NotFoundPage"));
const OwnTracksTutorial = lazy(() => import("./pages/OwnTracksTutorial"));
const PolygonEditor = lazy(() => import("./components/PolygonEditor"));
const TripsAdmin = lazy(() => import("./pages/TripsAdmin"));

export const appRouter = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route path="/dashboard" element={<LayoutHeaderUser />}>
        <Route path="" Component={Dashboard} />
        <Route path="polygoneditor" Component={PolygonEditor} />
        <Route path="drivers-map" Component={DriversMapView} />
        <Route path="trips" Component={TripsAdmin} />
      </Route>

      <Route element={<LayoutHeader />}>
        <Route path="/" element={<Drivers />} />
        <Route path="/login" Component={Login} />
      </Route>

      {/* Tutorial page without layout */}
      <Route path="/tutorial-owntracks/:id" Component={OwnTracksTutorial} />

      <Route path="/404" Component={NotFoundPage} />
    </>,
  ),
);
